<template>
  <div>
    <el-row :gutter="24" type="flex">
      <el-col :span="8">
        <div class="recipe-static-div">
          <CardContainer>
            <div class="static-div">
              <div class="static-left">
                <img
                  class="recipe-static-logo"
                  src="@/assets/cookbook_icon_total_cookbook.png"
                  alt=""
                  width="48px"
                  height="48px"
                />
              </div>
              <div class="static-right">
                <div class="title">
                  {{ $t('RecipeManage.listRecipeTotal') }}
                </div>
                <div class="totalData">
                  {{
                    this.staticData.totalCount
                      ? formatNumWithComma(this.staticData.totalCount, 0)
                      : 0
                  }}
                </div>
                <div class="addData">
                  <span class="addData-tips">{{ $t('RecipeManage.listTips1') }}</span>
                  <span class="addData-data">
                    {{
                      this.staticData.thisMonthCount
                        ? formatNumWithComma(this.staticData.thisMonthCount, 0)
                        : 0
                    }}</span
                  >
                </div>
              </div>
            </div>
          </CardContainer>
        </div>
        <div>
          <CardContainer class="recipe-static-div">
            <div class="static-div">
              <div class="static-left">
                <img
                  class="recipe-static-logo"
                  src="@/assets/cookbook_icon_total_download.png"
                  alt=""
                  width="48px"
                  height="48px"
                />
              </div>
              <div class="static-right">
                <div class="title">
                  {{ $t('RecipeManage.listTips2') }}
                </div>
                <div class="totalData">
                  {{
                    this.staticData.downloadCount
                      ? formatNumWithComma(this.staticData.downloadCount, 0)
                      : 0
                  }}
                </div>
                <div class="addData">
                  <span class="addData-tips">{{ $t('RecipeManage.listTips1') }}</span>
                  <span class="addData-data">
                    {{
                      this.staticData.thisMonthDownloadCount
                        ? formatNumWithComma(this.staticData.thisMonthDownloadCount, 0)
                        : 0
                    }}</span
                  >
                </div>
              </div>
            </div>
          </CardContainer>
        </div>
      </el-col>
      <el-col :span="8">
        <CardContainer><div class="device-add-count" id="getStatisticImg"></div></CardContainer>
      </el-col>
      <el-col :span="8">
        <CardContainer><div class="device-add-count" id="getStatisticImg2"></div></CardContainer>
      </el-col>
    </el-row>
    <CardContainer>
      <div class="btn-group">
        <hl-button type="primary" @click="add" v-if="this.addRole">
          {{ $t('Common.create') }}
        </hl-button>
        <el-dropdown style="margin: auto 8px;" @command="handleCommand">
          <el-button type="primary" plain size="small" style="font-size: 14px;padding: 8px 15px">
            {{ $t('Common.batchOperation') }}<i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="published" v-if="this.updateCookbookPublishStatusRole">
              {{ $t('Common.publish') }}</el-dropdown-item
            >
            <el-dropdown-item command="unpublished" v-if="this.updateCookbookPublishStatusRole">{{
              $t('RecipeManage.listUnpublished')
            }}</el-dropdown-item>
            <el-dropdown-item command="delete" v-if="this.deleteRole">{{
              $t('Common.delete')
            }}</el-dropdown-item>
            <el-dropdown-item command="updateType" v-if="this.updateCookbookTypeRole">{{
              $t('RecipeManage.listUpdateCookbookType')
            }}</el-dropdown-item>
            <el-dropdown-item command="updateModel" v-if="this.updateCookbookProductIdRole">{{
              $t('RecipeManage.listUpdateModel')
            }}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <!--        <hl-button type="secondary">
          {{ $t('Common.importData') }}
        </hl-button>-->
        <!--        <hl-button type="text" size="small">-->
        <!--          {{ $t('Common.downloadTemplate') }}-->
        <!--        </hl-button>-->
      </div>
      <CommonForm @search="formSearch" :form-json="formjson" />
      <CommonTable
        ref="table"
        :data="tableData"
        :total="total"
        :operation="operation"
        @change="handleTableChange"
        @operation="handleOperation"
        :table-json="tablejson"
        @sort="sortChange"
        :needSelection="true"
        @select="handleSelect"
      >
      </CommonTable>
      <TypeEdit
        :rows="selectList"
        @refresh="refresh"
        v-if="updateType"
        :visible.sync="updateType"
      />
      <ModelEdit
        :rows="selectList"
        @refresh="formSearch(cacheData, cachePage)"
        v-if="updateModel"
        :visible.sync="updateModel"
      />
    </CardContainer>
  </div>
</template>

<script>
import formjson from './Model/Formjson.Index'
import tablejson from './Model/Tablejson.Index'
import formTableMixin from '@/mixins/formTableMixin'
import getRoleFromPath from '@/mixins/getRoleFromPath'
import TypeEdit from './components/TypeEdit'
import ModelEdit from './components/ModelEdit'
import { formatNumWithComma } from '@/utils/utils'
const echarts = require('echarts')
import { sortMap } from '@/config/status'
import { getRoleByOperationCode } from '@/authorized'
export default {
  name: 'index',
  mixins: [formTableMixin, getRoleFromPath],
  components: {
    TypeEdit,
    ModelEdit
  },
  data() {
    return {
      formjson,
      tablejson,
      operation: [
        {
          name: this.$t('Common.detail'),
          icon: 'icon-detail_16',
          type: 'detail',
          hide: () => {
            return !this.detailRole
          }
        },
        {
          name: this.$t('Common.tips3'),
          icon: 'icon-set_language',
          type: 'lang',
          hide: (row) => {
            return !this.setCookbookLangRole || row.state === 'Y'
          }
        },
        {
          name: this.$t('Common.copy'),
          icon: 'icon-copy',
          type: 'copy',
          hide: () => {
            return !this.copyRole
          }
        },
        {
          name: this.$t('Common.edit'),
          icon: 'icon-edit_16',
          type: 'edit',
          hide: (row) => {
            return !this.updateRole || row.state === 'Y'
          }
        },
        {
          name: this.$t('Common.publish'),
          icon: 'icon-publish',
          type: 'published',
          hide: (row) => {
            return !this.updateCookbookPublishStatusRole || row.state === 'Y'
          }
        },
        {
          name: this.$t('RecipeManage.listUnpublished'),
          icon: 'icon-unpublish',
          type: 'unpublished',
          hide: (row) => {
            return !this.updateCookbookPublishStatusRole || row.state === 'N'
          }
        },
        {
          name: this.$t('Common.delete'),
          icon: 'icon-del_16',
          type: 'delete',
          hide: (row) => {
            return !this.deleteRole || row.state === 'Y'
          }
        }
      ],
      queryApi: this.$api.recipe.list_cookbook,
      row: {},
      extraQueryParams: {},
      staticData: {},
      selectList: [],
      updateType: false,
      updateModel: false,

      staticPieType: [],
      staticPieStatus: []
    }
  },
  computed: {
    roleChildList() {
      return this.role.childList
    },
    // 新建
    addRole() {
      let val = getRoleByOperationCode(this.roleChildList, 'add')
      return val ? val.isPermission == 'Y' : false
    },
    // 编辑
    updateRole() {
      let val = getRoleByOperationCode(this.roleChildList, 'update')
      return val ? val.isPermission == 'Y' : false
    },
    // 详情
    detailRole() {
      let val = getRoleByOperationCode(this.roleChildList, 'detail')
      return val ? val.isPermission == 'Y' : false
    },
    // 删除
    deleteRole() {
      let val = getRoleByOperationCode(this.roleChildList, 'del')
      return val ? val.isPermission == 'Y' : false
    },
    // 复制
    copyRole() {
      let val = getRoleByOperationCode(this.roleChildList, 'copy')
      return val ? val.isPermission == 'Y' : false
    },
    // 配置语言
    setCookbookLangRole() {
      let val = getRoleByOperationCode(this.roleChildList, 'setCookbookLang')
      return val ? val.isPermission == 'Y' : false
    },
    // 取消发布 / 发布
    updateCookbookPublishStatusRole() {
      let val = getRoleByOperationCode(this.roleChildList, 'updateCookbookPublishStatus')
      return val ? val.isPermission == 'Y' : false
    },
    // 更改适用型号
    updateCookbookProductIdRole() {
      let val = getRoleByOperationCode(this.roleChildList, 'updateCookbookProductId')
      return val ? val.isPermission == 'Y' : false
    },
    // 更改菜谱类型
    updateCookbookTypeRole() {
      let val = getRoleByOperationCode(this.roleChildList, 'updateCookbookType')
      return val ? val.isPermission == 'Y' : false
    }
  },
  created() {
    this.getStaticData()
  },
  mounted() {
    this.$nextTick(() => {
      this.getStatisticImg()
      this.getStatisticImg2()
    })
  },
  methods: {
    formatNumWithComma,
    //刷新
    refresh() {
      this.getStaticData()
      this.$nextTick(() => {
        this.getStatisticImg()
        this.getStatisticImg2()
      })
      this.formSearch()
    },
    //初始化菜谱分类统计图
    getStatisticImg() {
      console.log('initChart')
      let chartDom = document.getElementById('getStatisticImg')
      window.addEventListener('resize', () => {
        chartDom.resize()
      })
      let myChart = echarts.init(chartDom)
      let option

      option = {
        // title: {
        //   text: 'Referer of a Website',
        //   subtext: 'Fake Data',
        //   left: 'center'
        // },
        color: [
          '#2046C7',
          '#88C36C',
          '#FAC858',
          '#EF6767',
          '#9661BC',
          '#70C1E1',
          '#3CAB77',
          '#FC8452',
          '#5377B7',
          '#F08BB4'
        ],
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b} : {c} ({d}%)'
        },
        legend: {
          orient: 'horizontal',
          left: 'center',
          top: 'bottom',
          itemWidth: 8, //图例宽度
          itemHeight: 8 //图例高度
        },
        series: [
          {
            name: this.$t('RecipeManage.typeRecipeType'),
            type: 'pie',
            radius: '50%',
            data: this.staticPieType,
            center: ['50%', '40%'],
            label: {
              normal: {
                formatter: '{b}\n({d}%)',
                // formatter: function(params) {
                //   return  {b}+"</br>"+params.value
                // },
                textStyle: {
                  fontWeight: 'normal',
                  fontSize: 12,
                  color: '#666666'
                }
              }
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      }

      option && myChart.setOption(option)
    },
    //初始化菜谱发布统计图
    getStatisticImg2() {
      console.log('initChart')
      let chartDom = document.getElementById('getStatisticImg2')
      let myChart = echarts.init(chartDom)
      let option
      window.addEventListener('resize', () => {
        chartDom.resize()
      })
      option = {
        // title: {
        //   text: 'Referer of a Website',
        //   subtext: 'Fake Data',
        //   left: 'center'
        // },
        color: ['#2046C7', '#88C36C'],

        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b} : {c} ({d}%)'
        },
        legend: {
          orient: 'horizontal',
          left: 'center',
          top: 'bottom',
          itemWidth: 8, //图例宽度
          itemHeight: 8 //图例高度
        },
        series: [
          {
            name: this.$t('RecipeManage.listPublishStatus'),
            type: 'pie',
            radius: ['20%', '50%'],
            center: ['50%', '40%'],
            avoidLabelOverlap: false,
            data: this.staticPieStatus,
            label: {
              normal: {
                formatter: '{b}\n({d}%)',
                textStyle: {
                  fontWeight: 'normal',
                  fontSize: 12,
                  color: '#666666'
                }
              }
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      }

      option && myChart.setOption(option)
    },
    //批量操作命令
    handleCommand(command) {
      console.log(command, this.selectList)
      let selectList = JSON.parse(JSON.stringify(this.selectList))
      if (selectList.length === 0) {
        this.$message.warning(`${this.$t('RecipeManage.listTips12')}`)
      } else {
        if (command === 'published') {
          //批量发布
          if (selectList.some((item) => item.state === 'Y')) {
            this.$message.warning(`${this.$t('RecipeManage.listTips13')}`)
          } else {
            let ids = selectList.map((item) => {
              return item.id
            })
            this.handlePublished(ids)
          }
        } else if (command === 'unpublished') {
          //批量取消发布
          if (selectList.some((item) => item.state === 'N')) {
            this.$message.warning(`${this.$t('RecipeManage.listTips14')}`)
          } else {
            let ids = selectList.map((item) => {
              return item.id
            })
            this.handleUnpublished(ids)
          }
        } else if (command === 'delete') {
          //批量发布
          if (selectList.some((item) => item.state === 'Y')) {
            this.$message.warning(`${this.$t('RecipeManage.listTips13')}`)
          } else {
            let ids = selectList.map((item) => {
              return item.id
            })
            this.handleDelete(ids)
          }
        } else if (command === 'updateType') {
          this.updateType = true
        } else if (command === 'updateModel') {
          this.updateModel = true
        }
      }
    },
    //列表选择
    handleSelect(list) {
      this.selectList = list
    },
    //列表操作命令
    handleOperation(data) {
      const { type, row } = data
      switch (type) {
        case 'detail':
          this.handleDetail(row)
          break
        case 'lang':
          this.handleLang(row)
          break
        case 'edit':
          this.handleEdit(row)
          break
        case 'delete':
          this.handleDelete([row.id])
          break
        case 'copy':
          this.handleCopy(row)
          break
        case 'published':
          this.handlePublished([row.id])
          break
        case 'unpublished':
          this.handleUnpublished([row.id])
          break
      }
    },
    //编辑
    handleEdit(row) {
      this.row = row
      const { href } = this.$router.resolve({
        name: 'RecipeEdit',
        query: {
          id: row.id
        }
      })
      window.open(href, '_blank')
    },
    //详请
    handleDetail(row) {
      this.row = row
      const { href } = this.$router.resolve({
        name: 'RecipeDetail',
        query: {
          id: row.id
        }
      })
      window.open(href, '_blank')
    },
    //语言配置
    handleLang(row) {
      this.row = row
      const { href } = this.$router.resolve({
        name: 'RecipeLanguage',
        query: {
          id: row.id
        }
      })
      window.open(href, '_blank')
    },
    //删除
    handleDelete(ids) {
      this.$confirm(`${this.$t('RecipeManage.listTips15')}`, `${this.$t('Common.operationTips')}`, {
        confirmButtonText: this.$t('Common.confirm'),
        cancelButtonText: this.$t('Common.cancel'),
        type: 'warning'
      })
        .then(() => {
          // let params = {
          //   id: ids
          // }
          const config = {
            headers: {
              'Content-Type': 'application/json'
            }
          }
          this.$ajax
            .post(this.$api.recipe.delete_cookbook, ids, config)
            .then(() => {
              this.$message.success(`${this.$t('Common.delSuccess')}`)
              const pageObj = {
                ...this.cachePage
              }
              if (ids.length === 1) {
                if (this.tableData.length <= 1) {
                  if (this.cachePage.pageNum - 1 >= 1) {
                    pageObj.pageNum = this.cachePage.pageNum - 1
                  }
                }
              } else {
                pageObj.pageNum = 1
              }
              this.formSearch(this.cacheData, pageObj)
              this.getStaticData()
              this.$nextTick(() => {
                this.getStatisticImg()
                this.getStatisticImg2()
              })
            })
            .catch(() => {})
        })
        .catch(() => {})
    },
    //复制
    handleCopy(row) {
      this.row = row
      const { href } = this.$router.resolve({
        name: 'RecipeAdd',
        query: {
          copyId: row.id
        }
      })
      window.open(href, '_blank')
    },
    //发布
    handlePublished(ids) {
      this.$confirm(
        `${this.$t('RecipeManage.listTips16')}`,
        `${this.$t('Common.confirmPublish')}`,
        {
          confirmButtonText: this.$t('Common.confirm'),
          cancelButtonText: this.$t('Common.cancel'),
          type: 'warning',
          beforeClose: (action, instance, done) => {
            if (action === 'confirm') {
              instance.confirmButtonLoading = true
              // instance.confirmButtonText = '执行中...';
              let params = {
                ids: ids,
                state: 'Y'
              }
              const config = {
                // timeout:10000,
                headers: {
                  'Content-Type': 'application/json'
                }
              }
              this.$ajax
                .post(this.$api.recipe.update_cookbook_publishStatus, params, config)
                .then((res) => {
                  if (res.code === 100) {
                    done()
                    this.$message.success(`${this.$t('Common.operationSuccess')}`)
                    this.refresh()
                  }
                })
                .catch((err) => {
                  console.log('err', err)
                })
                .finally(() => {
                  instance.confirmButtonLoading = false
                })
            } else {
              done()
            }
          }
        }
      )
      // .then(() => {
      //   let params = {
      //     ids: ids,
      //     state: 'Y'
      //   }
      //   const config = {
      //     headers: {
      //       'Content-Type': 'application/json'
      //     }
      //   }
      //   this.$ajax
      //     .post(this.$api.recipe.update_cookbook_publishStatus, params, config)
      //     .then(() => {
      //       this.$message.success(`${this.$t('Common.operationSuccess')}`)
      //       this.refresh()
      //     })
      //     .catch(() => {})
      // })
      // .catch(() => {})
    },
    //取消发布
    handleUnpublished(ids) {
      this.$confirm(`${this.$t('RecipeManage.listTips17')}`, `${this.$t('Common.cancelPublish')}`, {
        confirmButtonText: this.$t('Common.confirm'),
        cancelButtonText: this.$t('Common.cancel'),
        type: 'warning'
      })
        .then(() => {
          let params = {
            ids: ids,
            state: 'N'
          }
          const config = {
            headers: {
              'Content-Type': 'application/json'
            }
          }
          this.$ajax
            .post(this.$api.recipe.update_cookbook_publishStatus, params, config)
            .then(() => {
              this.$message.success(`${this.$t('Common.operationSuccess')}`)
              // const pageObj = {
              //   ...this.cachePage
              // }
              //
              // this.formSearch(this.cacheData, pageObj)
              this.refresh()
            })
            .catch(() => {})
        })
        .catch(() => {})
    },
    //获取统计数据
    getStaticData() {
      this.$ajax
        .get(this.$api.recipe.static_cookbook)
        .then((res) => {
          if (res.data) {
            this.staticData = res.data
            let arrState = []
            arrState = res.data.groupByStateCountDtos.map((state) => {
              return {
                value: state.count,
                name: this.$t(`RecipeManage.list${state.state}`)
              }
            })
            this.staticPieStatus = arrState

            let arrType = []
            arrType = res.data.groupByTypeIdCountDtos.map((type) => {
              return {
                value: type.count,
                name: type.typeName
              }
            })
            this.staticPieType = arrType
            this.$nextTick(() => {
              this.getStatisticImg()
              this.getStatisticImg2()
            })
          }
        })
        .catch(() => {})
    },
    //排序操作
    sortChange(obj) {
      this.extraQueryParams.sortParam = obj[0].prop
      this.extraQueryParams.sortType = sortMap[obj[0].order]
      this.cachePage = null
      this.$nextTick(() => {
        this.formSearch()
      })
    },
    //查询列表
    formSearch(data, pageObj) {
      console.log(this.extraQueryParams)
      if (!data) {
        data = this.cacheData
      }
      let params = {
        ...data,
        ...this.extraQueryParams
      }
      console.log('params', params)
      this.search(params, pageObj, this.queryApi)
    },
    //新增
    add() {
      this.row = {}
      const { href } = this.$router.resolve({
        name: 'RecipeAdd'
      })
      window.open(href, '_blank')
    }
  }
}
</script>

<style lang="scss" scoped>
.device-add-count {
  width: 100%;
  //height: 100%;
  // width: 400px;
  height: 264px;
}
.hl-empty {
  margin: 78px auto;
}
.recipe-static-div {
  margin-bottom: 24px;
  .static-div {
    display: flex;
    align-items: center;
    .static-left {
      width: 48px;
      height: 48px;
      margin-right: 24px;
      //border: 1px dashed #666666;
    }
    .static-right {
      .title {
        color: #666666;
        font-size: 16px;
        line-height: 24px;
      }
      .totalData {
        font-family: Barlow-SemiBold;
        font-size: 36px;
        font-weight: 600;
        color: #333333;
        line-height: 44px;
      }
      .addData {
        display: flex;
        align-items: center;
        .addData-tips {
          color: #666666;
          line-height: 22px;
          padding-right: 8px;
        }
        .addData-data {
          font-size: 20px;
          font-weight: 600;
          color: #333333;
          line-height: 28px;
        }
      }
    }
  }
}
.btn-group {
  margin-bottom: 16px;
  display: flex;
  align-items: center;
}
</style>
